export const confcallModes = [
  ['self_dial', 'Selbst einwählen'],
  ['inbound_dialin', 'Andere einwählen lassen'],
  ['outbound_invite', 'Teilnehmer anrufen und einladen'],
];
export const confcallLimits = [
  ['max_rooms', 'Konfigurierbare Räume'],
  ['max_active_conferences', 'Gleichzeitig laufende Konferenzen'],
  ['max_human_participants', 'Menschen je Konferenz'],
  ['max_ai_participants', 'KIs je Konferenz'],
  ['max_participants', 'Teilnehmer insgesamt je Konferenz'],
  ['max_outbound_calls', 'Gleichzeitige ausgehende Verbindungen'],
  ['max_call_duration_seconds', 'Maximale Gesprächsdauer in Sekunden'],
];
export const isOptionsModule = key => ['confcall', 'number_extensions'].includes(key);
export function emptyModuleValue(key) {
  if (key === 'number_extensions') return { version: 1, max_extensions: '' };
  if (key === 'confcall') return { version: 1, ...Object.fromEntries(confcallModes.map(([field]) => [field, false])), ...Object.fromEntries(confcallLimits.map(([field]) => [field, ''])) };
  return { limit: '', tlds: [] };
}
export function parseParamValue(raw, key) {
  const out = emptyModuleValue(key);
  if (raw == null || String(raw).trim() === '') return out;
  const value = String(raw).trim();
  if (value.startsWith('{')) {
    try {
      const object = JSON.parse(value);
      if (isOptionsModule(key)) return { ...out, ...object };
      if (object.limit != null && Number.isFinite(Number(object.limit))) out.limit = String(parseInt(object.limit, 10));
      if (Array.isArray(object.tlds)) out.tlds = object.tlds.map(String).filter(Boolean);
    } catch (_) { /* Leere Pflichtfelder werden vom Backend nicht freigegeben. */ }
  } else if (/^\d+$/.test(value) && !isOptionsModule(key)) out.limit = value;
  return out;
}
export function serializeParamValue(value, key) {
  if (!value) return null;
  if (isOptionsModule(key) || Object.prototype.hasOwnProperty.call(value, 'version')) {
    const result = { ...value };
    const limits = key === 'number_extensions' || Object.prototype.hasOwnProperty.call(value, 'max_extensions') ? [['max_extensions']] : confcallLimits;
    for (const [field] of limits) {
      if (typeof result[field] === 'string' && /^\d+$/.test(result[field].trim())) result[field] = Number(result[field].trim());
    }
    return JSON.stringify(result);
  }
  const limit = value.limit != null ? String(value.limit).trim() : '';
  const tlds = Array.isArray(value.tlds) ? value.tlds.filter(Boolean) : [];
  if (tlds.length) return JSON.stringify({ tlds, ...(limit !== '' && /^\d+$/.test(limit) ? { limit: Number(limit) } : {}) });
  return limit !== '' && /^\d+$/.test(limit) ? limit : null;
}
